import React from 'react';

import TextBox from '@components/TextBox/TextBox';
import MobileListBox from '@components/MobileListBox/MobileListBox';
import ImportImages from '@src/importImages';

const Clouds = ImportImages('/home/clouds.jpg');
const JsiLogo = ImportImages('/jsi-logo.png');

const mobile = props => {
  const styles = {
    backgroundImage: `url(${Clouds}), url(${JsiLogo})`,
    backgroundBlendMode: 'multiply',
    backgroundSize: 'auto 100%',
    backgroundPosition: 'top center',
    height: '500px'
  };

  return (
    <React.Fragment>
      <div
        className={'d-flex align-items-center pt-5 pb-5 pl-2 pr-2 w-100'}
        style={styles}
      >
        <TextBox {...props.mainContent} />
      </div>
      {props.boxs.map(box => (
        <MobileListBox
          hideNav={true}
          key={box.id}
          activeBoxId={props.activeBox.id}
          box={box}
          click={() => props.click(box)}
        />
      ))}
    </React.Fragment>
  );
};

export default mobile;



// WEBPACK FOOTER //
// ./src/components/SuiteKey/Benefits/Mobile/Mobile.js